/* eslint-disable @typescript-eslint/no-explicit-any */
import { env } from "../../../../env";
import { _single } from "../EntityCatalog";

function useFetch() {
  const urlDomain =
    window.location.protocol +
    "//" +
    window.location.hostname +
    (window.location.port ? ":" + window.location.port : "");

  const getService = async (route: string): Promise<any> => {
    const url = urlDomain + route;

    _single.spinner(true);

    try {
      // const response = await fetch("https://develop.advantage.com.co/quickdataerp/ping");
      const response = await fetch(url);


      if (!response.ok) {
        throw new Error(`Error en la respuesta de la API: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    } finally {
      _single.spinner(false);
    }
  };

  return { getService };
}

export default useFetch;
